import { NavLink } from 'react-router-dom';

import './404.scss';

const PageNotFound = () => (
  <div className='page-not-found-container'>
    <div className='page-not-found-body'>
      <div className='top-bar'>
        <div className='title'>404</div>
        <p className='subtitle'>Page not found</p>
      </div>
      <div className='bottom-bar'>
        <div className='alert alert-dark'>
          Page you are trying to visit is unavailable now.
          <br />
          Please, try again or visit&nbsp;
          <NavLink to='/'>home page</NavLink>
        </div>
      </div>
    </div>
  </div>
);

export default PageNotFound;
